$( document ).ready(function() {
  $('body').addClass('is-transitioning'); 
        setTimeout(function() {
           $('body').removeClass('is-transitioning');
           $('body').addClass('transition-ending');
           setTimeout(function() { 
               $('body').removeClass('transition-ending');
             $('#MainContent').css('opacity','1');
           }, 1500); 
        }, 1000);  

  
  $(document).on('click', 'a', function(){
      $.cookie("cookieName", "firstSetremove");
  });

 if (typeof $.cookie('cookieName') === 'undefined') {
   console.log('undefined');
   } else {
   console.log('defined');
         var acookie =  $.cookie("cookieName");
        //  alert(acookie)
        if(acookie === 'firstSetremove'){
         // alert(acookie)
          $('#progress_div').addClass('showbar');
          $('#progress_div').show();
          $.cookie("cookieName", null);
        } 
   
     }
});

setTimeout(function() {
$('.custom-hat__price .price.price--large bdi').html(function(){	
    var text= $(this).text().split(' ');
    var last = text.pop();
    return text.join(" ") + (text.length > 0 ? ' <span class="currency_code">'+last+'</span>' : last);   
});
}, 2000);
/*Material custom js*/

$(document).on('click', '.mw-option__swatch-image', function(){
  var check_option=$(this).parents(".mw-option__container").find(".mw-option__control");
 
  if(check_option.is(':checked'))
  {
    $("body").trigger("click");  
  }
});

$(document).on('click', '.mw-option input[type=checkbox].mw-option__control', function(){
    var optionVal = $(this).val();
   $('.mw-option__value[data-value-id="'+optionVal+'"]').addClass('custom__option-select');

   if( $(this).find('.custom__option-select').length ){}else{     
     $(document).find('input[type=checkbox]').each(function(indec){

       //if ($('input.checkbox_check').is(':checked')) {
        var value = $(this).val();
       // console.log(value);
     });  

   }
  
})

$(document).on('click', '.custom-hat_content .ct_field .material', function(){

if($(document).find('.mw-option.Material').length){

  var textareaLength=$('.Standard-personalisation.gold-lettering-quote textarea.mw-option__control').attr('maxlength');
  $('.Standard-personalisation.gold-lettering-quote textarea.mw-option__control').attr('maxlength',30);

  var textareaLength=$('.prh-textarea.Standard-personalisation textarea.mw-option__control').attr('maxlength');
  $('.prh-textarea.Standard-personalisation textarea.mw-option__control').attr('maxlength',6);
}
  
  
})

$(document).on('click','.Crown.Heading .mw-option__value .mw-label', function() {
      var Text=$(this).text();
     $('#ctfieldCrown .ct_data .height_data').text(Text);
});
$(document).on('click','.Crown.Shape .mw-option__value .mw-label', function() {
      var Text=$(this).text();
     $('#ctfieldCrown .ct_data .shape_data').text(Text);
});

$(document).on('click','.Brim.width .mw-option__value .mw-label', function() {
      var Text=$(this).text();
     $('#ctfieldBrim .ct_data .width_data').text(Text);
});
$(document).on('click','.Brim.Brim-Shape .mw-option__value .mw-label', function() {
      var Text=$(this).text();
     $('#ctfieldBrim .ct_data .shape_data').text(Text);
});

$(document).on('click','.Brim.Brim-Edge-finish .mw-option__value .mw-label', function() {
      var Text=$(this).text();
     $('#ctfieldBrim .ct_data .Edgefinish_data').text(Text);
});

$(document).on('click','.Hatband.style .mw-option__value .mw-label', function() {
      var Text=$(this).text();
  $('#ctfieldHatband .ct_data .Hatband_data').text(Text); 

});

$(document).on('click','.size_box .ct_select-option .select__select li', function(){
      var selectValue=$(this).attr("value");
    
  $('.custom-hat variant-selects .product-form__input--dropdown[data-option-slug="size"] option').each(function(){
     var appSelectOption=$(this).attr("value");
      if(selectValue==appSelectOption){
        $('.size_box .ct_select-option .select__select li').attr("selected","selected");
        $('.custom-hat variant-selects .product-form__input--dropdown[data-option-slug="size"] option').attr("selected","selected");
      }else{
        $('.custom-hat variant-selects .product-form__input--dropdown[data-option-slug="size"] option').removeAttr("selected","selected");
        $('.size_box .ct_select-option .select__select li').removeAttr("selected","selected");
      }
  
  }); 
});



$(document).on('click','.Windcord.Extra .mw-stack.mw-stack--vertical.mw-stack--spacing-tight .mw-stack__item:nth-child(2)', function(){

 var dataValueId=$(this).parent('.mw-stack').closest(".mw-option__value ").attr("data-value-id");
//  alert(dataValueId)
 $(this).prev('.mw-stack__item').find('.mw-label').trigger('click');
  $(".Windcord.Extra .mw-option__value").each(function(){
    var alldataValueId=$(this).attr("data-value-id");
    if(dataValueId==alldataValueId){
      $(this).addClass('ExtraCls');
      var Extravalue=$(".Windcord.Extra .ExtraCls .mw-text.mw-option__value-text").text();

      var windCordList = $(".Windcord.Extra .mw-option__value--selected .mw-text.mw-option__value-text").map(function() { 
        return  $(this).text();
      }).get().join(' , '); 
      $('.ct_field .Extra_data').text(windCordList);  
     // $('.ct_field .Extra_data').text(Extravalue);      
    }else{       
    //   $(this).removeClass('ExtraCls');
      $('.ct_field .Extra_data').text();
    }
  });  
 // $(this).text('added'); 
   var valueId= $(this).parents('.mw-option__value').attr('data-value-id');
 // alert(valueId);
      if($('#'+valueId).prop("checked") == true){
          console.log("Checkbox is checked.");
        $('[data-value-id="'+valueId+'"]').addClass('ExtraCls');
        $('[data-value-id="'+valueId+'"] .mw-stack--spacing-tight .mw-stack__item:nth-child(2)').text('Added');
      }
      else if($('#'+valueId).prop("checked") == false){
          console.log("Checkbox is unchecked.");
        $('[data-value-id="'+valueId+'"]').removeClass('ExtraCls');
        $('[data-value-id="'+valueId+'"] .mw-stack--spacing-tight .mw-stack__item:nth-child(2)').text('Add');
      }
  
 });

//1st child
$(document).on('click','.Windcord.Extra .mw-stack.mw-stack--vertical.mw-stack--spacing-tight .mw-stack__item:nth-child(1)', function(){

 var dataValueId=$(this).parent('.mw-stack').closest(".mw-option__value ").attr("data-value-id");
//  alert(dataValueId)
// $(this).prev('.mw-stack__item').find('.mw-label').trigger('click');
  $(".Windcord.Extra .mw-option__value").each(function(){
    var alldataValueId=$(this).attr("data-value-id");
    if(dataValueId==alldataValueId){
      $(this).addClass('ExtraCls');
      var Extravalue=$(".Windcord.Extra .ExtraCls .mw-text.mw-option__value-text").text();

      var windCordList = $(".Windcord.Extra .ExtraCls .mw-text.mw-option__value-text").map(function() { 
        return  $(this).text();
      }).get().join(' , '); 
      $('.ct_field .Extra_data').text(windCordList);  
     // $('.ct_field .Extra_data').text(Extravalue);      
    }else{       
    //   $(this).removeClass('ExtraCls');
      $('.ct_field .Extra_data').text();
    }
  });  
 // $(this).text('added'); 
   var valueId= $(this).parents('.mw-option__value').attr('data-value-id');
 // alert(valueId);
      if($('#'+valueId).prop("checked") == true){
          // console.log("Checkbox is checked.");
        $('[data-value-id="'+valueId+'"]').addClass('ExtraCls');
        $('[data-value-id="'+valueId+'"] .mw-stack--spacing-tight .mw-stack__item:nth-child(2)').text('Added');
      }
      else if($('#'+valueId).prop("checked") == false){
          // console.log("Checkbox is unchecked.");
        $('[data-value-id="'+valueId+'"]').removeClass('ExtraCls');
        $('[data-value-id="'+valueId+'"] .mw-stack--spacing-tight .mw-stack__item:nth-child(2)').text('Add');
      }
  
 });


$(document).on('click','.ct_select-option .select__select li', function(){
  var ulVal = $(this).attr('value');
  $('label.form__label span#sizect').text(ulVal);
   $('.custom-selectOpt select option').each(function(){
    var selOpt = $(this).attr('data-variant'); 
    if(ulVal == selOpt){
      var varId = $(this).val();
      $('.shopify-product-form input[name="id"]').val(varId);
     // console.log(varId);
    }
  });
  // $('.size_box .ct_select-option .select__select').css("opacity", 0);
});

/* MY JS */
$(document).on('click', '.custom-hat_content .ct_field .material', function(){
   $('.mw-option .mw-option__value .mw-option__swatch-image').each(function(){
      var color_code =$(this).attr('alt');
      // console.log(color_code);
      $(this).parent().css('background-color',color_code);    
    });  
}); 

var infoText = '';
$(document).on('click', 'div#Material', function(){
   $('.mw-option .mw-option__value .mw-option__swatch-image').each(function(){
      var color_code =$(this).attr('alt');
       // console.log(color_code);
      $(this).parent().css('background-color',color_code);    
    });   
    $(document).find('.mw-option--type-multiswatch.Material').each(function(){
        var valueSpan = $(this).find('span.mw-text--style-strong');  
       var valueSpanText = valueSpan.text();   
        // console.log(valueSpanText);
          var infoText =  $(this).attr('data-colorinfo', valueSpanText);
             result = valueSpanText.split('-')[1];
  
    });     
});

  $(document).on('click', 'div#standard-Personalisation', function(){
      if($(document).find('textarea[placeholder="PRH"]').length){
         if($(document).find('.personalisationArea').length){}else{
              $('.prh-textarea.Standard-personalisation .mw-option__value').append('<textarea class="mw-option__control" id="prharea" placeholder="PRH" maxlength="6"></textarea>');
              $('.prh-textarea.Standard-personalisation').addClass('personalisationArea');
          }
      }
     if($(document).find('textarea[placeholder="Write your name, initials or favourite personal quote here"]').length){
         if($(document).find('.personalisationgoldArea').length){}else{
              $('.Standard-personalisation.gold-lettering-quote .mw-option__value').append('<textarea class="mw-option__control" id="goldarea" placeholder="Write your name, initials or favourite personal quote here" maxlength="30"></textarea>');
              $('.Standard-personalisation.gold-lettering-quote').addClass('personalisationgoldArea');
          }
      }
  });

   
$(document).on('click', '.Standard-personalisation.Punched-initials .mw-stack.mw-stack--vertical.mw-stack--spacing-tight .mw-stack__item:nth-child(2)', function(){
    var this_ = $(this);
    var boxVal =  $('.prh-textarea.Standard-personalisation textarea').val();    
    var prhVal = $('#prharea').val();
    $('textarea[placeholder="PRH"]').val(prhVal);
    //$('textarea[placeholder="PRH"]').trigger('click');
   
    if ($.trim(prhVal)){    
      $(this_).text('Added');
      $(this_).addClass("opacity_added"); 
      $('.prh-textarea.Standard-personalisation').addClass('addProperty');
      $('.mw-option--type-checkbox.Standard-personalisation.Punched-initials .mw-label').click();       
    }  
    if($('.mw-option--type-checkbox.Standard-personalisation.Punched-initials .mw-label input[type="checkbox"]').is(':checked')){}else{
      $(this_).text('Add');   
        $(this_).removeClass('opacity_added'); 
       $('textarea#prharea').val('');
       $('.prh-textarea.Standard-personalisation').removeClass('addProperty');
    }    
});
$(document).on('keyup', '#prharea', function(){  
   var prhVal = $('#prharea').val();
   var this_ = '.Standard-personalisation.Punched-initials .mw-stack.mw-stack--vertical.mw-stack--spacing-tight .mw-stack__item:nth-child(2)';
    if ($.trim(prhVal)){}else{
      $('.mw-option--type-checkbox.Standard-personalisation.Punched-initials .mw-label').click();       
       $(this_).text('Add');   
       $(this_).removeClass('opacity_added');  
      $('.prh-textarea.Standard-personalisation').removeClass('addProperty');
    }       
});

$(document).on('click', '.Standard-personalisation.Gold-lettering .mw-stack.mw-stack--vertical.mw-stack--spacing-tight .mw-stack__item:nth-child(2)', function(){
    var this_ = $(this);
    var boxVal =  $('.gold-lettering-quote.Standard-personalisation textarea').val();  
    var goldVal = $('#goldarea').val();
    $('textarea[placeholder="Write your name, initials or favourite personal quote here"]').val(goldVal);
   
     if ($.trim(goldVal)){    
      $(this_).text('Added');
      $(this_).addClass("opacity_added"); 
      $('.Standard-personalisation.gold-lettering-quote').addClass('addProperty');
      $('.mw-option--type-checkbox.Standard-personalisation.Gold-lettering .mw-label').click();       
     } 
    if($('.mw-option--type-checkbox.Standard-personalisation.Gold-lettering .mw-label input[type="checkbox"]').is(':checked')){}else{
      $(this_).text('Add');   
        $(this_).removeClass('opacity_added'); 
       $('#goldarea').val('');
       $('.Standard-personalisation.gold-lettering-quote').removeClass('addProperty');
    }   
}); 
$(document).on('keyup', '#goldarea', function(){  
   var goldVal = $('#goldarea').val();
   var this_ = '.Standard-personalisation.Gold-lettering .mw-stack.mw-stack--vertical.mw-stack--spacing-tight .mw-stack__item:nth-child(2)';
    if ($.trim(goldVal)){}else{
     $('.mw-option--type-checkbox.Standard-personalisation.Gold-lettering .mw-label').click();  
       $(this_).text('Add');   
            $(this_).removeClass('opacity_added'); 
             $('.Standard-personalisation.gold-lettering-quote').removeClass('addProperty');
    }       
});


/*Hatband  click on width and colour start*/
$(document).on('click','.Hatband.Hatband-width', function(){ 
   $(this).find('label').toggleClass("Hatband-widthLabel");
   $('.Hatband.Hatband-width .mw-option__container').toggle();
});
$(document).on('click','.Hatband.Hatband-width .mw-option__container .mw-option__value .mw-option__button', function(){
    $(this).parents(".Hatband.Hatband-width").find(".mw-option__container").hide(); 
      var this__ = this
 //  setTimeout (function(){
     $(this__).parents(".Hatband.Hatband-width").find('label').removeClass("Hatband-widthLabel");
     var main_text=$(this__).parents(".Hatband.Hatband-width").find('.mw-stack--vertical .mw-stack__item:first-child .mw-text--style-strong').hide();
    
 //  },500);
}); 

$(document).on('click','.Hatband.Hatband-color', function(){ 
   $(this).find('.mw-label').toggleClass("Hatband-colourLabel");
   $('.Hatband.Hatband-color .mw-option__container').toggle();  
});
$(document).on('click','.Hatband.Hatband-color .mw-option__container .mw-option__value .mw-option__button', function(){
    $(this).parents(".Hatband.Hatband-color").find(".mw-option__container").hide(); 
      var this__ = this
 //  setTimeout (function(){
     $(this__).parents(".Hatband.Hatband-color").find('label').removeClass("Hatband-colourLabel");
     $(this__).parents(".Hatband.Hatband-color").find('.mw-stack--vertical .mw-stack__item:first-child .mw-text--style-strong').hide();
 //  },500);
}); 
/*Hatband  click on width and colour end*/

/*Brim click on edge-finish bound start*/
$(document).on('click','.Brim.Edge-colour', function(){ 
   $(this).find('.mw-label').toggleClass("Edge-colourLabel");
   $('.Brim.Edge-colour .mw-option__container').toggle();
});
$(document).on('click','.Brim.Edge-colour .mw-option__container .mw-option__value .mw-option__button', function(){
    $(this).parents(".Brim.Edge-colour").find(".mw-option__container").hide(); 
      var this__ = this
     $(this__).parents(".Brim.Edge-colour").find('label').removeClass("Edge-colourLabel");
     $(this__).parents(".Brim.Edge-colour").find('.mw-stack--vertical .mw-stack__item:first-child .mw-text--style-strong').hide();
}); 
/*Brim click on edge-finish bound end*/

$(document).on('click', '.Material .mw-option__media-image', function(){
  if ($('.mw-option--type-multiswatch .mw-option__control').is(':checked')) {
 var checkedVal =  $('.mw-option--type-multiswatch .mw-option__control:checked+.mw-option__swatch-media').parents('.Material').attr('data-colorinfo');
   var colorVal=$('.mw-option--type-multiswatch .mw-option__control:checked+.mw-option__swatch-media .mw-option__swatch-image').attr('alt');
  }else{
     var checkedVal = '';
      var colorVal='';
  }
   var selectedVal =  $('.mw-option__value--selected').parents('.Material').attr('data-colorinfo');
 console.log(checkedVal);
  $('#materialOption .ct_data .colorValue').text(checkedVal);
 
   $('#materialOption .ct_data .colorCode').css("background-color",colorVal);
  
});
$(document).on('click', '.mw-stack__item.mw-stack__item--fill label.mw-label', function(){
   var imageAlt = $(".mw-option__value--selected .mw-option__swatch-image").attr('alt');
        // console.log(imageAlt);
});
$(document).on("click",'.mw-option .mw-option__value .mw-option__swatch-image', function(){
   var colorVal=$(this).attr('alt');
   $('#materialOption .ct_data .colorCode').css("background-color",colorVal);
});



//Require Option Value 
   $(document).on('click', 'div#demo.custom_addtocart', function(){   
     $(this).addClass('form_validations');
    if ($('.ct_data span.colorValue').is(':empty')){
      $('div#Material').addClass('required-warning');
   }else{
     $('div#Material').removeClass('required-warning');
   }
   if ($('#ctfieldCrown .ct_data span.height_data').is(':empty') || $('#ctfieldCrown .ct_data span.shape_data').is(':empty')){
      $('div#Crown').addClass('required-warning'); 
      }else{
     $('div#Crown').removeClass('required-warning'); 
   }
   if ($('#ctfieldBrim .ct_data span.width_data').is(':empty') || $('#ctfieldBrim .ct_data span.shape_data').is(':empty') || $('#ctfieldBrim .ct_data span.Edgefinish_data').is(':empty')){
      $('div#Brim').addClass('required-warning'); 
      }else{
     $('div#Brim').removeClass('required-warning'); 
   } 
    if ($('#ctfieldHatband .ct_data .Hatband_data').is(':empty')){
      $('#Hatband').addClass('required-warning'); 
      }else{
     $('#Hatband').removeClass('required-warning'); 
   } 
  });

$(document).on('click', '.Material.arrow-right',function () {
    if ($('.ct_data span.colorValue').is(':empty')){
      $('div#Material').addClass('required-warning');
   }else{
     $('div#Material').removeClass('required-warning');
   }
});
$(document).on('click', '.Crown.arrow-right',function () {     
   if ($('#ctfieldCrown .ct_data span.height_data').is(':empty') || $('#ctfieldCrown .ct_data span.shape_data').is(':empty')){
      $('div#Crown').addClass('required-warning'); 
      }else{
     $('div#Crown').removeClass('required-warning'); 
   }
});
$(document).on('click', '.Brim.arrow-right',function () {     
   if ($('#ctfieldBrim .ct_data span.width_data').is(':empty') || $('#ctfieldBrim .ct_data span.shape_data').is(':empty') || $('#ctfieldBrim .ct_data span.Edgefinish_data').is(':empty')){
      $('div#Brim').addClass('required-warning'); 
      }else{
     $('div#Brim').removeClass('required-warning'); 
   }
});
$(document).on('click', '.Hatband.arrow-right',function () { 
 var HatbandComment = $('.mw-option.mw-option--type-text.mw-option--required.Hatband.Hatband-comment').find('input.mw-option__control').val();
 
  $('#ctfieldHatband .ct_data .hatband_color').text(HatbandComment);
  if ($('#ctfieldHatband .ct_data .Hatband_data').is(':empty')){
      $('#Hatband').addClass('required-warning'); 
  } else if($(document).find('.mw-option--type-button.Hatband.Hatband-width.mw-hidden').length || $(document).find('.mw-option--type-button.Hatband.Hatband-color.mw-hidden').length || $(document).find('.mw-option--type-button.Hatband.Hatband-Bow-type.mw-hidden').length || $(document).find('.HatbandSingleComment.mw-hidden').length){
     $('#Hatband').removeClass('required-warning');      
        $('#ctfieldHatband .ct_data .hatband_color').text(' ');
        $('#ctfieldHatband .ct_data .hatband_width').text(' ');
        $('#ctfieldHatband .ct_data .bow_type').text(' ');
  } else{
     if ($('#ctfieldHatband .ct_data .hatband_width').is(':empty') || $('#ctfieldHatband .ct_data .hatband_color').is(':empty') || $('#ctfieldHatband .ct_data .bow_type').is(':empty') && $('#ctfieldHatband .ct_data .hatband_comment').is(':empty')){
          $('#Hatband').addClass('required-warning'); 
     }else{
        $('#Hatband').removeClass('required-warning'); 
     } 
  } 
});



  //ITG BAND 24-09
$(document).on('click', '.Hatband.arrow-right',function () {  
  var width = $('.Hatband.Hatband-width .mw-stack__item .mw-option__value.mw-option__value--selected').find('.mw-text.mw-option__value-text').text();
  var color = $('.Hatband.Hatband-color .mw-stack__item .mw-option__value.mw-option__value--selected').find('.mw-text.mw-option__value-text').text();
  var bowtype = $('.Hatband.Hatband-Bow-type .mw-stack__item .mw-option__value.mw-option__value--selected').find('.mw-text.mw-option__value-text').text();
  var comment = $('.Hatband.HatbandSingleComment').find('.mw-option__control').val();

  if($(document).find('.mw-option--type-button.Hatband.Hatband-width.mw-hidden').length){
    $('#ctfieldHatband .ct_data .hatband_width').text('');
  }else{
    if(width){
        $('#ctfieldHatband .ct_data .hatband_width').text(width);
    }
  }

  if($(document).find('.mw-option--type-button.Hatband.Hatband-color.mw-hidden').length){
    $('#ctfieldHatband .ct_data .hatband_color').text('');
  }else{ 
    if(color){
      $('#ctfieldHatband .ct_data .hatband_color').text(color);
    }
  } 
  
  if($(document).find('.mw-option--type-button.Hatband.Hatband-Bow-type.mw-hidden').length){
    $('#ctfieldHatband .ct_data .bow_type').text('');
  }else{   
   if(bowtype){
     $('#ctfieldHatband .ct_data .bow_type').text(bowtype);
   }
  }
  if($(document).find('.mw-option--type-button.Hatband.HatbandSingleComment.mw-hidden').length){
    $('#ctfieldHatband .ct_data .hatband_comment').text('');
  }else{ 
    if(comment){
      $('#ctfieldHatband .ct_data .hatband_comment').text(comment);
    }
  }

  
  if ($('#ctfieldHatband .ct_data .Hatband_data').is(':empty')){
      $('#Hatband').addClass('required-warning'); 
  } else if($(document).find('.mw-option--type-button.Hatband.Hatband-width.mw-hidden').length || $(document).find('.mw-option--type-button.Hatband.Hatband-color.mw-hidden').length || $(document).find('.mw-option--type-button.Hatband.Hatband-Bow-type.mw-hidden').length && $(document).find('.HatbandSingleComment.mw-hidden').length){
     $('#Hatband').removeClass('required-warning'); 
  } else{
     if ($('#ctfieldHatband .ct_data .hatband_width').is(':empty') || $('#ctfieldHatband .ct_data .hatband_color').is(':empty') || $('#ctfieldHatband .ct_data .bow_type').is(':empty') && $('#ctfieldHatband .ct_data .hatband_comment').is(':empty')){
          $('#Hatband').addClass('required-warning'); 
     }else{
        $('#Hatband').removeClass('required-warning'); 
     } 
  } 
});
  



$(document).on('click', '.ct_field .material', function(){
   $('.custom-hat .product__info-container .custom-hat_content').css("opacity", "0");
});
$(document).on('click','.custom-hat .product__info-container .mw-apo-container .arrow-right', function(){
   $('.custom-hat .product__info-container .custom-hat_content').css("opacity", "1");
});



/*Choose size Drop down js*/
$(document).on('click', '.custom-hat .size_box .ct_select-dropdown .form__label', function(){
   $(this).toggleClass("arrow_up");
   $(this).parents(".custom-hat .size_box .ct_select-dropdown").find(".ct_select-option .select__select").slideToggle();
});
$(document).on('click', '.custom-hat .size_box .ct_select-dropdown .select__select li', function(){
   $(this).parents(".custom-hat .size_box .ct_select-dropdown").find(".form__label").removeClass("arrow_up");
   $(this).addClass("addValue").siblings().removeClass("addValue");
   $(this).parent(".custom-hat .size_box .select__select").slideUp();
});

$(document).on('click', '.arrow-right.Standard-personalisation .mw-option__media-image', function(){
   var prharea = ''; var goldarea = '';
      if($(document).find('.Standard-personalisation.Punched-initials .mw-option__container').find('.opacity_added').length){
          prharea = $('textarea#prharea').val();
        $('.ct_data span.Personalisation_Initials').text(prharea);
      }else{
        $('.ct_data span.Personalisation_Initials').text('');
      }
   if($(document).find('.Standard-personalisation.Gold-lettering .mw-option__container').find('.opacity_added').length){
          goldarea = $('textarea#goldarea').val();
        $('.ct_data span.Personalisation_Gold').text(goldarea);
      }else{
         $('.ct_data span.Personalisation_Gold').text('');
      }
});





$(document).ready(function(){
   $(".Windcord.Extra .mw-text.mw-option__value-text").click(function(){
    // alert()
    //alert($(this).text())
    }, function(){
    $(this).css("background-color", "pink");
  });

 
  
 $(document).on('click', 'div#demo.custom_addtocart', function(){
       if($(document).find('.mw-option--required.HatbandSingleComment').length){  
          if(!$('.mw-option--required.HatbandSingleComment').hasClass('mw-hidden')){   
              if($('.mw-option--required.HatbandSingleComment').find('.mw-option__helptext.mw-text.mw-text--style-negative').hasClass('mw-hidden')){
                  $('div#Hatband').removeClass('required-warning');
              }else{
                $('div#Hatband').addClass('required-warning');
              }
           }
       }

       if($(document).find('.mw-option--required.Hatband.Hatband-width').length){  
          if(!$('.mw-option--required.Hatband.Hatband-width').hasClass('mw-hidden')){   
              if($('.mw-option--required.Hatband.Hatband-width').find('.mw-option__helptext.mw-text.mw-text--style-negative').hasClass('mw-hidden')){
                  $('div#Hatband').removeClass('required-warning');
              }else{
                $('div#Hatband').addClass('required-warning');
              }
           }
       }

       if($(document).find('.mw-option--required.Hatband.Hatband-Bow-type').length){  
          if(!$('.mw-option--required.Hatband.Hatband-Bow-type').hasClass('mw-hidden')){   
              if($('.mw-option--required.Hatband.Hatband-Bow-type').find('.mw-option__helptext.mw-text.mw-text--style-negative').hasClass('mw-hidden')){
                  $('div#Hatband').removeClass('required-warning');
              }else{
                $('div#Hatband').addClass('required-warning');
              }
           }
       }  

    if($(document).find('.mw-option--required.Brim.Edge-colour').length){  
          if(!$('.mw-option--required.Brim.Edge-colour').hasClass('mw-hidden')){   
              if($('.mw-option--required.Brim.Edge-colour').find('.mw-option__helptext.mw-text.mw-text--style-negative').hasClass('mw-hidden')){
                  $('div#Brim').removeClass('required-warning');
              }else{
                $('div#Brim').addClass('required-warning');
              }
           }
       }  

    if($(document).find('.mw-option--type-button.Choose-size.select_choose-size').length){  
        $('.mw-option--type-button.Choose-size.select_choose-size .mw-stack__item:nth-child(2) .mw-option__container .mw-option__value ').each(function(){
                  if(!$(this).hasClass('mw-option__value--selected')){
                     $('.mw-option--required.Choose-size.select_choose-size').removeClass('required-warning');
                  }else{
                    $('.mw-option--required.Choose-size.select_choose-size').addClass('required-warning');
                  }
        });
     } 
   
   if ($('.ct_data span.colorValue').is(':empty')){
       $('div#Material').addClass('required-warning');
   }else{
      $('button.product-form__submit.button.button--full-width.mw-apo-add-to-cart-cloned').trigger('click');
   }
  
 }) ;
  
})





